/**
 * @module experience/shop/product-details
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { Routes } from '@angular/router';
import { DeviceDetailsLandingComponent } from './components/device-details-landing/device-details-landing.component';
import { ProductReviewsLandingComponent } from './components/product-reviews-landing/product-reviews-landing.component';

// @TODO angular dont have optional parameters so two url's are added
export const PRODUCT_DETAILS_ROUTES: Routes = [
  {
    path: 'read-reviews',
    component: ProductReviewsLandingComponent,
  },
  {
    path: ':canonicalUrl',
    component: DeviceDetailsLandingComponent,
  },
  {
    path: ':canonicalUrl/:color',
    component: DeviceDetailsLandingComponent,
  },
  {
    path: ':canonicalUrl/:color/:memory',
    component: DeviceDetailsLandingComponent,
  },
];
